const { supportsLocalStorageApi } = require('./support');
const {
  clearMetric,
  checkMetric,
  getMetric,
  appendMetric,
  trackMetric,
} = require('./collector');

const getBufferSchema = () => ({ data: [], expireTime: 0 });

const clearBuffer = (key) => {
  if (!supportsLocalStorageApi()) {
    clearMetric(key);
    return;
  }

  window.localStorage.removeItem(key);
};

const checkBuffer = (key) => {
  if (!supportsLocalStorageApi()) {
    return checkMetric(key);
  }

  return !!window.localStorage.getItem(key);
};

const getBuffer = (key, alt = null) => {
  if (!supportsLocalStorageApi()) {
    return getMetric(key, alt);
  }

  const result = JSON.parse(window.localStorage.getItem(key));

  if (!result) {
    return alt;
  }

  if (result.expireTime <= Date.now()) {
    clearBuffer(key);

    return alt;
  }

  return result.data;
};

const appendToBuffer = (key, value, maxAge = 0) => {
  if (!supportsLocalStorageApi()) {
    appendMetric(key, value);
    return;
  }

  const buffer = getBuffer(key, getBufferSchema());
  buffer.data.push(value);
  buffer.expireTime = Date.now() + maxAge;

  window.localStorage.setItem(key, JSON.stringify(buffer));
};

const addToBuffer = (key, value, maxAge = 0) => {
  if (!supportsLocalStorageApi()) {
    trackMetric(key, value);
    return;
  }

  const buffer = getBuffer(key, getBufferSchema());
  buffer.data = value;
  buffer.expireTime = Date.now() + maxAge;

  window.localStorage.setItem(key, JSON.stringify(buffer));
};

module.exports = {
  clearBuffer,
  checkBuffer,
  getBuffer,
  appendToBuffer,
  getBufferSchema,
  addToBuffer,
};
